export interface DockConstructor {
  id?: Number,
  title?: string,
  uuid?: string,
  active?: boolean,
  current?: Current,
}

export interface Current {
    status?: 0 | 1 | 2,
    time?: any,
    truck_id?: number,
    truck?: any,
    trailer_id?: number,
    trailer?: any,
}

export class Dock {
  id: Number;
  title: string;
  uuid: string;
  active: boolean;
  current: Current;

  constructor(args: DockConstructor = {}) {
    Object.assign(this, args)
  }
}



// WEBPACK FOOTER //
// ./src/models/Dock.ts